const { site, language_switch } = window.tg;

/**
 * @param {string} formID
 * @param {string} status
 * @param {string} reason
 */
function showFormAlert(formID , status , reason = '', btnID = '') {
    const formEl = document.getElementById(formID);

    if (!formEl) {
        console.error('Could not find form element with ID: ' + formID);
        return;
    }

    const cardBodyEl = formEl.parentElement;
    const alertEl = document.createElement('div');
    const faIconEl = document.createElement('span');

    var formBtn;
    if (btnID != '') {
        formBtn = document.getElementById(btnID);
    }

    let faIcon = 'fa-exclamation-triangle';
    let alertText = '';
    let alertClass = "alert-error";

    // Check if previous alert message and remove it
    if (cardBodyEl.querySelector('.alert') !== null) {
        const previousAlertEl = cardBodyEl.querySelector('.alert');
        previousAlertEl.parentNode.removeChild(previousAlertEl);
    } else {
        const openTray = document.querySelector('#js-tray-inner-frame')
        const trayName = Alpine.store('general').tray.openTray;
        if (site == 'ls' && openTray && !['user-verification'].includes(trayName)) {
            Alpine.store('general').tray.height += language_switch === 'af' ? 135 : 85;
            openTray.style.height = Alpine.store('general').tray.height + Alpine.store('general').tray.heightUnit;

            alertEl.classList.add('position-static');
        }
    }

    // Determine the type of alert
    if (status === 'WARNING') {
        faIcon = 'fa-exclamation-triangle';
        alertClass = "alert-warning";
    } else if (status === 'SUCCESS') {
        faIcon = 'fa-check';
        alertClass = "alert-success";
    }

    if (reason !== '') {
        alertText = reason;
    } else {
        //when a reason is sent back as the error status (process_payment.php and unlink_invite.php)
        alertText = _t("kd.user.generic_error_new","Something went wrong. Please reload or contact an agent to assist you.");
    }

    let alertTextEl = document.createElement('div');
    alertTextEl.innerHTML = alertText;

    // Define type of icon
    faIconEl.classList.add('fal', faIcon , 'mr-3', 'fa-lg');

    // Add icon and text to badge element
    alertEl.appendChild(faIconEl);
    alertEl.appendChild(alertTextEl);

    if (formEl.id === 'js-refund-voucher-form') {
        formEl.prepend(alertEl);
    } else if (formEl.id === 'js-request-credit-card-form') {
        formEl.prepend(alertEl);
    } else if (['js-review-accomm-form', 'js-review-company-form', 'js-review-social-form'].indexOf(formEl.id) != -1) {
        formBtn.parentNode.insertBefore(alertEl, formBtn); // review forms, show form error right above button
    } else if (site == 'vy' && formEl.id === 'js-modal-signup-form') {
        formEl.querySelector('.signup-step-body').append(alertEl)
    } else if (site === 'ls' && language_switch === 'af' && formEl.id === 'js-modal-signup-form') {
        alertEl.classList.add('py-2');
        formEl.append(alertEl);
    } else if (['js-modal-password-change-form', 'js-modal-update-itc-form', 'js-modal-signup-form', 'js-modal-login-form', 'js-modal-password-form', 'js-modal-otp-form', 'js-modal-password-reset-form', 'js-modal-wishlist-invite-form', 'js-partner-membership-login-form', 'js-cancel-payment-form', 'js-ops-confirm-stay-form'].indexOf(formEl.id) != -1) {
        formEl.append(alertEl);
    } else {
        //If referenceNode is the last child within its parent element, that's fine, because referenceNode.nextSibling will be null
        formEl.parentNode.insertBefore(alertEl, cardBodyEl.firstChild);
    }

    if (formEl.id === 'js-breakdown-panel' || formEl.id === 'js-modal-wishlist-invite-form') {
        alertEl.classList.add('mt-3');
    }

    if (formEl.id === 'js-verify-otp-form') {
        alertEl.classList.add('rounded-8');
    }

    alertEl.classList.add('alert', alertClass, 'd-flex', 'align-items-center');
    alertEl.classList.remove('d-none');
}

function hideFormAlert(formId = null) {

    var alertElement = document.querySelector('#js-error-message');

    if (formId) {
        const formEl = document.getElementById(formId);
        const cardBodyEl = formEl.parentElement;
        // Check if previous alert message
        if (cardBodyEl.querySelector('.alert') !== null) {
            alertElement = cardBodyEl.querySelector('.alert')
        }
    }

    if (!(alertElement instanceof HTMLDivElement)) {
        throw new Error('Selector should match an HTMLDivElement.');
    }

    alertElement.classList.add('d-none');
    alertElement.classList.remove('d-flex');
}

export {showFormAlert, hideFormAlert};
